import { css } from "@emotion/react";
import { Icon, useModal } from "swing-components";

import { FilterChip, FilterModal } from "~components";
import { areFiltersSet, translate, useIsDesktop } from "~utils";

import { LocalStorageFilterValueTypes, ThreadedData, UnifiedFilterType } from "./types";

type FilterBarProps = ThreadedData;

export function FilterBar(props: FilterBarProps) {
  const { ls, setLs } = props;
  const isDesktop = useIsDesktop();

  const { openModal, closeModal } = useModal({
    component: <FilterModal onDismiss={() => closeModal()} {...props} />,
    modalOptions: {
      cssClass: isDesktop ? undefined : "action-sheet-modal",
      breakpoints: isDesktop ? undefined : [0, 1],
      initialBreakpoint: isDesktop ? undefined : 1,
    },
  });

  const totalFiltersSet =
    ls.requestLength?.length + ls.requestType?.length + ls.startingDate?.length || 0;

  const toggleListItem = (key: keyof LocalStorageFilterValueTypes, value: UnifiedFilterType) => {
    setLs((old) => {
      const list = (old[key] ?? []) as UnifiedFilterType[];
      return list.includes(value)
        ? { ...old, [key]: list.filter((i) => i !== value) }
        : { ...old, [key]: [...list, value] };
    });
  };

  return (
    <div
      className="mw-800"
      css={css`
        width: 100%;
        overflow: scroll;
        margin-top: 16px;
        display: flex;
        position: relative;
        -ms-overflow-style: none;
        scrollbar-width: none;
        ::-webkit-scrollbar {
          display: none;
        }
        @media (min-width: 900px) {
          padding-left: 16px;
        }
      `}
    >
      <div
        css={css`
          position: sticky;
          left: 0;
          z-index: 2;
          padding: 0 16px;
          background: var(--ion-background-color);

          @media (min-width: 900px) {
            padding-left: 0px;
          }
        `}
      >
        <div css={{ display: "flex", gap: 16, paddingRight: 16 }}>
          <FilterChip selected={areFiltersSet(ls)} onClick={() => openModal()}>
            <Icon name="Filter" />
            {totalFiltersSet > 0 && totalFiltersSet}
          </FilterChip>
          <FilterChip
            selected={ls.startingDate.includes("soon")}
            showDismiss
            onClick={() => toggleListItem("startingDate", "soon")}
          >
            {translate("FILTER_LABEL_STARTS_SOON")}
          </FilterChip>
          <FilterChip
            selected={ls.requestType.includes("worked-before")}
            showDismiss
            onClick={() => toggleListItem("requestType", "worked-before")}
          >
            {translate("FILTER_LABEL_WORKED_BEFORE")}
          </FilterChip>
          <FilterChip
            selected={ls.requestType.includes("new-today")}
            showDismiss
            onClick={() => toggleListItem("requestType", "new-today")}
          >
            {translate("FILTER_LABEL_NEW_TODAY")}
          </FilterChip>
        </div>
      </div>
    </div>
  );
}
